import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { TextField } from '@mui/material';
import { isEqual } from 'lodash/lang';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { STUDY_COST_PER_MILEAGE_UPDATED } from '../../../../../constants/notificationMessages';
import { handleFinLedgerEventIdFieldValidationError } from '../../../../../services/handlers';
import { NSPS_STUDY } from '../../../../../services/i18n/namespaces';

const AmountNumericFormat = React.forwardRef(function(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      getInputRef={ref}
      {...other}
      onValueChange={values => {
        onChange(values.value);
      }}
      thousandSeparator
      decimalScale={3}
      prefix="$"
    />
  );
});

export default function CostPerMileageUpdateModal({ modalBox, currentCostPerMileage, handleCostPerMileageUpdate }) {
  const { t } = useTranslation();
  const [costPerMileage, setCostPerMileage] = useState(currentCostPerMileage ?? '');

  const isDisabledButton = useMemo(
    function() {
      return isEqual(currentCostPerMileage, costPerMileage);
    },
    [currentCostPerMileage, costPerMileage]
  );

  return (
    <>
      <ModalBoxes.Header onClose={closeModal}>
        {t('reimbursement.updateCostPerMileage', { ns: NSPS_STUDY })}
      </ModalBoxes.Header>
      <ModalBoxes.Body>
        <div>
          <TextField
            label={t('reimbursement.costPerMileage', { ns: NSPS_STUDY })}
            value={costPerMileage ? costPerMileage / 1000 : ''}
            onChange={value => setCostPerMileage(value * 1000)}
            name="numberformat"
            id="formatted-numberformat-input"
            variant="standard"
            slotProps={{
              input: {
                inputComponent: AmountNumericFormat
              }
            }}
          />
        </div>
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority={'medium'} onClick={closeModal}>
            {t('cancel')}
          </Button>
          <Button onClick={onSave} disabled={isDisabledButton}>
            {t('save')}
          </Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </>
  );

  function onSave() {
    handleCostPerMileageUpdate(costPerMileage)
      .then(function() {
        NotificationManager.success(STUDY_COST_PER_MILEAGE_UPDATED);
        closeModal();
      })
      .catch(handleFinLedgerEventIdFieldValidationError);
  }

  function closeModal() {
    modalBox.close();
  }
}

CostPerMileageUpdateModal.className = 'cost-per-mileage-update-modal';
CostPerMileageUpdateModal.size = 'w350';
